<div class="popup">
  <span>You have not given permission to use camera and mic on this page</span>
  <!-- <span> Click <span (click)="accessMicrophone.emit()" class="href-button">here</span> to get access</span> -->
</div>
